import React from 'react'
import MuiTextField from '@mui/material/TextField'

import styles from '@components/form/text_field.module.scss'

const TextField = React.forwardRef((props, ref) => (
  <MuiTextField
    ref={ref}
    classes={{ root: styles.text_field }}
    FormHelperTextProps={{ classes: { error: styles.text_field__error } }}
    InputProps={{
      classes: {
        root: styles.text_field__input,
        notchedOutline: styles.text_field__outline,
        focused: styles['text_field__input--focused'],
        error: styles['text_field__input--error'],
      },
    }}
    InputLabelProps={{
      classes: { root: styles.text_field__label, error: styles.text_field__label },
    }}
    variant="outlined"
    {...props}
  />
))

export { TextField }
